/**
 * Determines whether the given value is an object.
 * @param value A value to check.
 */
export function isObject(value: any): value is { [key: string]: any } {
  return value !== null && typeof value === 'object';
}
